import React from 'react';

const SIZES = {
  sm: {
    title: 'text-base md:text-lg',
    sub: 'text-[7px] md:text-[8px]',
    dot: 'w-1 h-1 mx-1.5',
    gap: 'mt-1',
  },
  md: {
    title: 'text-xl md:text-2xl',
    sub: 'text-[9px] md:text-[10px]',
    dot: 'w-1.5 h-1.5 mx-2',
    gap: 'mt-1.5',
  },
  lg: {
    title: 'text-3xl md:text-4xl',
    sub: 'text-[10px] md:text-xs',
    dot: 'w-2 h-2 mx-2.5',
    gap: 'mt-2',
  },
  hero: {
    title: 'text-4xl md:text-6xl',
    sub: 'text-[11px] md:text-sm',
    dot: 'w-2 h-2 md:w-2.5 md:h-2.5 mx-2.5 md:mx-3',
    gap: 'mt-2 md:mt-3',
  },
};

/**
 * Logo MAISON KA COUTURE.
 * - mode="text"  : reproduction typographique (Bodoni Moda + Montserrat fine)
 * - mode="image" : fichier logo officiel (fidélité pixel-perfect)
 *
 * La ligne « MAISON KA » du logo source est une police logo custom (stencil didone).
 * Bodoni Moda en est la meilleure approximation web ; l'image reste la référence exacte.
 */
const BrandLogo = ({
  mode = 'text',
  size = 'md',
  tone = 'dark',
  showSubline = true,
  className = '',
  ...props
}) => {
  const s = SIZES[size] || SIZES.md;

  const titleTone =
    tone === 'light'
      ? 'text-foreground'
      : tone === 'gold'
        ? 'text-gold'
        : tone === 'onDark'
          ? 'text-background'
          : 'text-foreground';
  const subTone =
    tone === 'light'
      ? 'text-foreground/70'
      : tone === 'gold'
        ? 'text-gold/80'
        : tone === 'onDark'
          ? 'text-background/70'
          : 'text-foreground/65';

  if (mode === 'image') {
    const imgClass =
      tone === 'light'
        ? 'h-auto w-auto max-h-14 md:max-h-16 object-contain'
        : 'h-auto w-auto max-h-14 md:max-h-16 object-contain brightness-0 invert';
    return (
      <img
        src="/images/logo-maison-ka-couture.png"
        alt="MAISON KA COUTURE"
        className={`${imgClass} ${className}`}
        {...props}
      />
    );
  }

  return (
    <span
      className={`inline-flex flex-col items-start leading-none select-none ${className}`}
      {...props}
    >
      <span className={`brand-logo-title uppercase ${titleTone} ${s.title}`}>
        <span className="brand-logo-maison">Maison</span>
        <span
          className={`inline-block shrink-0 rounded-full bg-gold align-middle ${s.dot}`}
          aria-hidden
        />
        <span className="brand-logo-ka">KA</span>
      </span>
      {showSubline && (
        <span className={`brand-logo-sub uppercase ${subTone} ${s.sub} ${s.gap}`}>
          Couture
        </span>
      )}
    </span>
  );
};

export default BrandLogo;
